import axios from "axios";

export const a = axios.create({
    baseURL: 'https://mynoteapp.pythonanywhere.com/api/v1/'
})